@if (initialized && activeNavigationItem) {
    <div class="cn-commission-rule-side mt-2">

        @if (activeNavigationItem.action === 'cn.CommissionRule') {
            @if (ruleWidget) {
                <mvs-widget [widgetData]="ruleWidget"></mvs-widget>
            }
        }

        @if (activeNavigationItem.action === 'cn.CommissionRuleTier') {
            @if (tierWidget) {
                <mvs-widget [widgetData]="tierWidget"></mvs-widget>
            }
        }

        @if (activeNavigationItem.action === 'cn.CommissionCondition') {
            @if (conditionWidget) {
                <mvs-widget [widgetData]="conditionWidget"></mvs-widget>
            }
        }

    </div>
}
